<!-- Footer Start -->
<div class="container-fluid bg-dark text-secondary px-5 mt-5">
    <div class="row gx-5">
        <div class="col-lg-8 col-md-6">
            <div class="row gx-5">
                <div class="col-lg-4 col-md-12 pt-5 mb-5">
                    <h4 class="text-uppercase text-light mb-4">{{ 'FOOTER.CONTACT.TITLE' | translate }}</h4>
                    <div class="d-flex mb-2">
                        <i class="bi bi-geo-alt text-primary me-2"></i>
                        <p class="mb-0">{{ 'FOOTER.CONTACT.ADDRESS' | translate }}</p>
                    </div>
                    <div class="d-flex mb-2">
                        <i class="bi bi-envelope-open text-primary me-2"></i>
                        <p class="mb-0">
                            <a [href]="'mailto:' + email">{{ email }}</a>
                        </p>
                    </div>
                    <div class="d-flex mb-2">
                        <i class="bi bi-telephone text-primary me-2"></i>
                        <p class="mb-0">{{ phone }}</p>
                    </div>
                    <div class="d-flex mt-4">
                        <a class="btn btn-primary btn-square rounded-circle me-2"
                            href="https://twitter.com/Wescotcorp"><i class="fab fa-twitter"></i></a>
                        <a class="btn btn-primary btn-square rounded-circle me-2"
                            href="https://web.facebook.com/profile.php?id=100063689845829"><i
                                class="fab fa-facebook-f"></i></a>
                        <a class="btn btn-primary btn-square rounded-circle me-2"
                            href="https://www.linkedin.com/in/wescot-corporation-2081b0263/"><i
                                class="fab fa-linkedin-in"></i></a>
                        <a class="btn btn-primary btn-square rounded-circle"
                            href="https://www.instagram.com/wescotcorporation/"><i class="fab fa-instagram"></i></a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-12 pt-0 pt-lg-5 mb-5">
                    <h4 class="text-uppercase text-light mb-4">{{ 'FOOTER.QUICK_LINKS.TITLE' | translate }}</h4>
                    <div class="d-flex flex-column justify-content-start">
                        <a *ngFor="let link of col2Links" [routerLink]="link.path" routerLinkActive="active"
                            class="text-secondary mb-2" style="text-decoration: none; cursor: pointer;">
                            <i class="bi bi-arrow-right text-primary me-2"></i>{{ link.label | translate }}
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-12 pt-0 pt-lg-5 mb-5">
                    <h4 class="text-uppercase text-light mb-4">{{ 'FOOTER.POPULAR_LINKS.TITLE' | translate }}</h4>
                    <div class="d-flex flex-column justify-content-start">
                        <a *ngFor="let link of col3Links" [routerLink]="link.path" routerLinkActive="active"
                            class="text-secondary mb-2" style="text-decoration: none; cursor: pointer;">
                            <i class="bi bi-arrow-right text-primary me-2"></i>{{ link.label | translate }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6">
            <div class="d-flex flex-column align-items-center justify-content-center text-center h-100 bg-primary p-5">
                <h4 class="text-uppercase text-white mb-4">{{ 'FOOTER.NEWSLETTER.TITLE' | translate }}</h4>
                <h6 class="text-uppercase text-white">{{ 'FOOTER.NEWSLETTER.SUBTITLE' | translate }}</h6>
                <p class="text-light">{{ 'FOOTER.NEWSLETTER.TEXT' | translate }}</p>
                <form (submit)="onSubscribe($event)">
                    <div class="input-group">
                        <input type="email" class="form-control border-white p-3"
                            [placeholder]="'FOOTER.NEWSLETTER.PLACEHOLDER' | translate" required>
                        <button class="btn btn-dark" type="submit">{{ 'FOOTER.NEWSLETTER.BUTTON' | translate }}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<div class="container-fluid py-4 py-lg-0 px-5" style="background: #111111;">
    <div class="row gx-5">
        <div class="col-lg-8">
            <div class="py-lg-4 text-center">
                <p class="text-secondary mb-0">&copy; <a class="text-light fw-bold" href="#">{{ 'FOOTER.COPYRIGHT.TEXT'
                        | translate }} {{
                        currentYear }}</a>. {{ 'FOOTER.COPYRIGHT.RIGHTS' | translate }}</p>
            </div>
        </div>
        <div class="col-lg-4" *ngIf="showPrivacyPolicy">
            <div class="py-lg-4 text-center credit">
                <p class="text-light mb-0"><a class="text-light fw-bold" [routerLink]="[privacyPolicyPath]">{{
                        'FOOTER.QUICK_LINKS.PRIVACY' | translate }}</a></p>
            </div>
        </div>
    </div>
</div>
<!-- Footer End -->